import React, { useState, MouseEventHandler, MouseEvent, useEffect, ReactNode } from 'react';

import { translate } from '@vimeo/i18n-runtime';

import { Locales } from '../setLanguage';
import { ContentFilterModal } from '../SettingsModal/ContentFilterModal';
import { LanguageSelectModal } from '../SettingsModal/LanguageSelectModal';
import { Modals } from '../SettingsModal/types';
import DesktopFooter from './desktop/MinimalFooter';
import MobileFooter from './mobile/MinimalFooter';

type Filters = Record<string, { rating: number; name: string }>;

interface Props {
  contentViewingPrefs?: {
    selected: number;
    filters: Filters;
    customFilters: Filters;
  };
  impressumQualifies?: boolean;
  locale: string;
  locales?: Locales[];
  localeLabels?: string[];
  xsrft: string;
}

export interface ModalCTAs {
  [key: string]: {
    text: ReactNode;
    open: MouseEventHandler;
  };
}

function MinimalFooter({
  contentViewingPrefs,
  impressumQualifies,
  locale,
  locales = [],
  localeLabels = [],
  xsrft,
}: Props) {
  const [activeModal, setActiveModal] = useState<Modals | null>(null);
  const [isDoNotSellReady, setIsDoNotSellReady] = useState(false);

  function setActive(modal: Modals) {
    return (event: MouseEvent) => {
      event.preventDefault();
      setActiveModal(modal);
    };
  }

  const modalCtas: ModalCTAs = {
    language: {
      text: translate('Language'),
      open: setActive(Modals.language),
    },
    contentPrefs: {
      text: translate('Mature content filter'),
      open: setActive(Modals.contentViewingPrefs),
    },
  };

  useEffect(() => {
    window.onload = () => setIsDoNotSellReady(true);
  }, []);

  return (
    <>
      <LanguageSelectModal
        active={activeModal === Modals.language}
        activeSet={setActiveModal}
        locale={locale}
        locales={locales}
        localeLabels={localeLabels}
        token={xsrft}
      />
      {contentViewingPrefs && (
        <ContentFilterModal
          active={activeModal === Modals.contentViewingPrefs}
          activeSet={setActiveModal}
          token={xsrft}
          contentViewingPrefs={contentViewingPrefs}
        />
      )}
      <MobileFooter
        impressumQualifies={impressumQualifies}
        modalCtas={modalCtas}
        isDoNotSellReady={isDoNotSellReady}
      />
      <DesktopFooter
        impressumQualifies={impressumQualifies}
        modalCtas={modalCtas}
        isDoNotSellReady={isDoNotSellReady}
      />
    </>
  );
}

export default MinimalFooter;
